import type { CollaboratorSummary } from '../../services/tasks/taskCollaborationService';
import { Avatar } from '../ui/Avatar';
import { CollaboratorLink } from '../collaborators/CollaboratorLink';

interface AssigneeAvatarsProps {
  assignees: CollaboratorSummary[];
  size?: 'xs' | 'sm';
  max?: number;
}

export function AssigneeAvatars({
  assignees,
  size = 'xs',
  max = 3,
}: AssigneeAvatarsProps) {
  if (assignees.length === 0) return null;
  const visible = assignees.slice(0, max);
  const overflow = assignees.length - visible.length;

  return (
    <div className="flex items-center -space-x-1.5">
      {visible.map((c) => (
        <CollaboratorLink
          key={c.id}
          collaboratorId={c.id}
          title={c.full_name}
          className="ring-2 ring-white rounded-full"
        >
          <Avatar name={c.full_name} src={c.avatar_url} size={size} />
        </CollaboratorLink>
      ))}
      {overflow > 0 && (
        <span
          className="ring-2 ring-white rounded-full bg-neutral-200 text-neutral-600 text-[10px] font-semibold flex items-center justify-center w-6 h-6"
          title={`+${overflow} autre(s)`}
        >
          +{overflow}
        </span>
      )}
    </div>
  );
}
